import BusinessProfile from './BusinessProfile';

export { default as Departments } from './Departments';
export { default as Staff } from './Staff';
export { default as Overview } from './Overview';

export default BusinessProfile;
